import React from 'react';
import PropTypes from 'prop-types';

import Input from 'src/app/components/Input';
import 'src/app/components/PasswordMask.scss';


class PasswordMask extends React.Component {
  state = {
    visible: false
  };

  toggleVisibility = () => this.setState((state) => ({ visible: !state.visible }));

  render() {
    const { visible } = this.state;
    const { inputRef, ...other } = this.props;
    const { toggleVisibility } = this;

    return (
      <div styleName="password-mask">

        <Input required
               type={ visible ? 'text' : 'password' }
               ref={ inputRef }
               {
                 ...other
               }
        />
        <button
          type="button"
          title={ visible ? 'Ukryj hasło' : 'Pokaż hasło' }
          styleName="password-mask__toggle-visibility"
          onClick={ toggleVisibility }
        >
          {visible ? 'visibility' : 'visibility_off'}
        </button>
      </div>
    );
  }
}

PasswordMask.propTypes = {
  inputRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired
};

export default PasswordMask;
